import React from 'react';
import KycGenericVerification from './KycGenericVerification';

export default function KycPanToBankAccount() {
  return (
    <KycGenericVerification
      title="PAN To Bank Account"
      description="Obtain bank account details from the PAN number. This API provides results for Insurance, Investment, Fintech, and Taxation industries."
      kycType="pan-to-bank-account"
      costField="panToBankAccountCost"
      submitLabel="Submit PAN To Bank Account"
      inputs={[
        {
          name: 'panNumber',
          label: 'PAN Number',
          placeholder: 'ABCDE1234F',
          maxLength: 10,
          formatter: (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10),
          validator: (value) => /^[A-Z]{5}\d{4}[A-Z]$/.test(String(value || '').toUpperCase()),
          errorMessage: 'Enter a valid PAN number'
        },
        {
          name: 'mobileNumber',
          label: 'Mobile Number',
          placeholder: '9876543210',
          maxLength: 10,
          formatter: (value) => String(value || '').replace(/\D/g, '').slice(0, 10),
          validator: (value) => /^\d{10}$/.test(String(value || '')),
          errorMessage: 'Enter a valid 10 digit mobile number'
        }
      ]}
      referenceFormatter={(item) => item.panNumber || 'N/A'}
    />
  );
}
